import { render, staticRenderFns } from "./SignalTokenMint.vue?vue&type=template&id=960149ec&scoped=true&"
import script from "./SignalTokenMint.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalTokenMint.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960149ec",
  null
  
)

export default component.exports